/**
 * `@Transform` body for `?ids=a,b` query params. Accepts both the comma-separated
 * form and repeated keys (`?ids=a&ids=b`, which Express turns into an array) and
 * drops blanks, so the class-validator rules see a clean `string[]`.
 */
export function splitCommaSeparatedIds(value: unknown): unknown {
  if (value === undefined || value === null) {
    return value;
  }
  return [value]
    .flat()
    .flatMap((chunk) => String(chunk).split(','))
    .map((id) => id.trim())
    .filter(Boolean);
}
